import { adminHttpClient } from '../commons/adminHttpClient'
import { NamedItemString } from 'domain/common/namedItem'

const getCompanyEmployeesFullNames = (excludeCompanyUserId: string): Promise<NamedItemString[]> =>
  adminHttpClient.get('/Companies/GetCompanyEmployeesFullNames', { excludeCompanyUserId })

export default getCompanyEmployeesFullNames
